function getFieldKey(field) {
    return field && (field.key || field.KEY || field.FLDNO)
}

function getFieldType(field) {
    return String((field && (field.EDCSS || field.edcss)) || '').toLowerCase()
}

export function escapeVeTableQueryValue(value) {
    return String(value).replace(/'/g, "''")
}

export function buildVeTableHeaderCondition(fields, values, options = {}) {
    const state = values || {}
    const seen = new Set()
    return (fields || []).reduce((condition, field) => {
        const key = getFieldKey(field)
        if (!key || seen.has(key) || !/^[A-Za-z0-9_]+$/.test(key)) return condition
        seen.add(key)
        const value = state[key]
        if (value === '' || value === null || value === undefined) return condition
        const type = options.typeOverrides && options.typeOverrides[key]
            ? String(options.typeOverrides[key]).toLowerCase()
            : getFieldType(field)
        const exactType = ['number', 'date', 'date2', 'time', 'select', 'checkbox'].includes(type)
        const defaultOperator = type === 'number' && options.numberOperatorDefault
            ? options.numberOperatorDefault
            : (exactType ? '=' : 'like')
        const comparisonOperators = ['=', '>', '<', '>=', '<=', '!=']
        const requestedOperator = state[`#OPER${key}`] || defaultOperator
        let operator = requestedOperator
        const dateLikeType = ['date', 'date2', 'time'].includes(type)
        const allowDateOperators = options.allowDateOperators !== false
        if (['select', 'checkbox'].includes(type) || (dateLikeType && !allowDateOperators)) {
            operator = '='
        } else if (dateLikeType && !comparisonOperators.includes(operator)) {
            operator = '='
        } else if (type === 'number' && !comparisonOperators.includes(operator)) {
            operator = options.numberOperatorDefault || '='
        }
        if (![...comparisonOperators, 'like'].includes(operator)) return condition
        if (type === 'number') {
            const normalized = String(value).trim()
            if (!/^-?\d+(\.\d+)?$/.test(normalized)) return condition
            return `${condition} and ${key}${operator}${normalized}`
        }
        const escaped = escapeVeTableQueryValue(String(value).trim())
        if (type === 'select' || type === 'checkbox') return `${condition} and ${key}='${escaped}'`
        if (type === 'date' || type === 'date2' || type === 'time') {
            const expression = typeof options.dateExpression === 'function' ? options.dateExpression(key) : key
            return `${condition} and ${expression}${operator}'${escaped}'`
        }
        return operator === 'like'
            ? `${condition} and upper(${key}) like upper('%${escaped}%')`
            : `${condition} and ${key}${operator}'${escaped}'`
    }, '')
}

export function buildVeTableFieldCondition(fields, key, value, operator = 'like', options = {}) {
    if (!isVeTableMetadataField(fields, key) || value === '' || value === null || value === undefined) return ''
    return buildVeTableHeaderCondition(fields, { [key]: value, [`#OPER${key}`]: operator }, options)
}

export function isVeTableMetadataField(fields, key) {
    return Boolean(key && (fields || []).some(field => getFieldKey(field) === key))
}
